import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-conf-predictive-layout',
  templateUrl: './conf-predictive-layout.component.html',
  styleUrls: ['./conf-predictive-layout.component.scss']
})
export class ConfPredictiveLayoutComponent implements OnInit {
  constructor( private router: Router) { }

  ngOnInit(): void {
    let confUrlSplit = this.router.url.split("/");
    const lobFromUrl = decodeURIComponent(confUrlSplit[2])
    const vcFromUrl = decodeURIComponent(confUrlSplit[3])
    let summarypath = ""
      switch (lobFromUrl) {
        case 'hcv': summarypath = '/configurator/hcv/hcv-summary'
        break 
        case 'ilmcv' : summarypath = '/configurator/ilmcv/ilmcv-summary'
        break;
        case 'scv' : summarypath = '/configurator/scv/scv-summary'
        break;
        case 'bus' : summarypath = '/configurator/bus/bus-summary'
        break;
        case 'winger' : summarypath = '/configurator/winger/winger-summary'
        break;
        case 'magic' :  summarypath = '/configurator/magic/magic-summary'
        break;
        default:
        break;
      }
      this.router.navigate([summarypath],{queryParams:{vc_no:vcFromUrl}});
	
  }

}
